import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { theme } from "../../../theme";
import BodySmall from "../typography/BodySmall";
import { AddIcon } from "../icons/AddIcon";
import { CrossIcon } from "../icons/CrossIcon";

interface Props {
  titleKey: string;
  selected: boolean;
  onSelect: () => void;
  addTag?: boolean;
  disabled?: boolean;
}

const Container = styled.button<{
  selected: boolean;
  addTag?: boolean;
  disabled?: boolean;
}>`
  padding: ${(props) => (props.addTag ? `2px 12px 2px 8px` : `2px 16px`)};
  border-radius: 12px;
  border: ${(props) =>
    props.addTag && !props.selected
      ? `1.25px dashed ${theme.colors.grey40}`
      : `1.25px solid ${theme.colors.grey40}`};
  background-color: ${(props) =>
    props.selected ? theme.colors.primaryBg : theme.colors.white};
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    border-color: ${(props) =>
      props.disabled ? theme.colors.disabled : theme.colors.primary};
  }
`;

const FilterChip: FC<Props> = ({
  titleKey,
  selected,
  onSelect,
  addTag,
  disabled,
}) => {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);
  const iconColor =
    addTag && !selected && !hovered
      ? theme.colors.textMuted
      : theme.colors.primary;
  return (
    <div>
      <Container
        selected={selected}
        addTag={addTag}
        disabled={disabled}
        aria-pressed={selected}
        onClick={disabled ? undefined : onSelect}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {addTag &&
          (selected ? (
            <CrossIcon color={iconColor} />
          ) : (
            <AddIcon color={iconColor} />
          ))}
        <BodySmall fontweight={600} color={iconColor}>
          {t(titleKey)}
        </BodySmall>
      </Container>
    </div>
  );
};

export default FilterChip;
